import { createDomain } from 'effector-root';

const domain = createDomain('WcSync (Page)');

export const onPageStarted = domain.event();